import styles from "@/pages/saleOperations/saleWorkBench/customerDetail/index.module.less";
import classNames from "classnames";
import {Avatar, Button, Tabs} from "antd";
import BuildInfo from "@/pages/clueManage/clueDetail/components/UserInfo/BuildInfo.tsx";
import Portrait from "@/pages/clueManage/clueDetail/components/UserInfo/Portrait.tsx";
import Service from "@/pages/clueManage/clueDetail/components/UserInfo/Service.tsx";
import React, {useContext, useEffect, useMemo} from "react";
import {useSetState} from "ahooks";
import ClueDetailContext from "@/pages/clueManage/clueDetail/clueDetailContext.ts";
import CheckThePhone from "@/components/CheckThePhone";
import { STags } from 'shj-components';
import dayjs from "dayjs";
import TrackInfo from "@/pages/clueManage/clueDetail/components/UserInfo/TrackInfo.tsx";
import {useSearchParams} from "react-router-dom";

const colors = ['rgba(255, 90, 38, 1)', 'rgba(245, 147, 0, 1)', 'rgba(43, 164, 113, 1)', 'rgba(0, 100, 255, 1)', 'rgba(136, 81, 237, 1)', 'rgba(214, 32, 105, 1)']

const UserInfo = () => {
  const [search] = useSearchParams()
  const saleClueId = search.get('saleClueId')
  const {detailState, trackDetail, viewPhoneKey} = useContext(ClueDetailContext)
  const [state, setState] = useSetState<any>({
    activeKey: '',
  })

  const items = [
    {
      key: '1',
      label: '线索信息',
      children:
          <div className={styles.basicOverScrollBox}>
            <BuildInfo />
          </div>
    },
    {
      key: '2',
      label: '客户需求',
      children:
          <div className={styles.basicOverScrollBox}>
            <Portrait/>
          </div>
    },
    {
      key: '3',
      label: '服务人员',
      children:
          <div className={styles.basicOverScrollBox}>
            <Service/>
          </div>
    },
  ]

  useEffect(() => {
    if (detailState.name) {
      document.title = detailState.name 
    }
    return () => {
      document.title = '积木云装'
    }
  }, [detailState])

  const tabs = useMemo(() => {
    const arr = items
    if(!saleClueId && ['DESIGN', 'TO_SHOP'].includes(detailState.status)){
      arr[0].label = '基本信息'
    }
    if (trackDetail.id && saleClueId) {
      arr.unshift({
        key: '4',
        label: '商机信息',
        children: <div className={styles.basicOverScrollBox}><TrackInfo detail={trackDetail}/></div>
      })
    }
    setState({activeKey: state.activeKey || arr[0]?.key})
    return items
  }, [trackDetail, detailState])

  return <>
    <div className={classNames([styles.flexBetweenStart, styles.mb10])}>
      <div className={styles.flexBetweenStart}>
        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Avatar
              size={36}
              style={{
                fontSize: '20px',
                backgroundColor: colors[Math.round(saleClueId ? Number(trackDetail?.id?.[trackDetail?.id?.length - 1] || 0) * 0.6 : Number(detailState?.id?.[detailState?.id?.length - 1] || 0) * 0.6)]
              }}
              className={classNames([styles.mr10])}>{ detailState.name?.[0] }</Avatar>
            <span className={classNames([styles.name])}>{detailState.name}</span>
          </div>
          <p className={classNames([styles.mb4, styles.mt8, styles.basicInfo])}>
            <span className={classNames([styles.greyText])}>{saleClueId ? '商机ID：' : '线索ID：'}</span>
            <span className={classNames([])}>{saleClueId ? trackDetail?.id : detailState.id}</span>
          </p>
          <p className={classNames([styles.mb4, styles.flexStart, styles.basicInfo])}>
            <span className={classNames([styles.greyText])}>电话号码：</span>
            <span style={{ height: '22px' }}>
              {detailState.phone && (
                  <CheckThePhone
                      clueId={detailState.id}
                      initValue={detailState.phone}
                      auth={viewPhoneKey}
                  />
              )}
            </span>
          </p>
          <p className={classNames([styles.mb8, styles.basicInfo])}>
            <span className={classNames([styles.greyText])}>最后跟进：</span>
            <span
                className={classNames([])}>{detailState.lastFollowTime && dayjs(detailState.lastFollowTime).format('YYYY-MM-DD HH:mm:ss')}</span>
          </p>
          <p>
            {
              (!saleClueId && detailState.status) ? <STags itemKey={detailState.status} /> : null
            }
          </p>
        </div>
      </div>
    </div>
    <Tabs
      style={{ flex: 1, overflowY: 'scroll' }}
      tabBarStyle={{ position: 'absolute', left: '15px', right: '15px', zIndex: 1, backgroundColor: '#fff' }}
      tabBarGutter={saleClueId ? 15: 25}
      more={{ visible: false }}
      items={tabs}
      activeKey={state.activeKey}
      onChange={(key) => setState({activeKey: key})}
    />
  </>
}

export default UserInfo
